import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Creator\OnboardingTourController::__invoke
* @see app/Http/Controllers/Creator/OnboardingTourController.php:14
* @route '/app/creator/onboarding-tour/complete'
*/
export const complete = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: complete.url(options),
    method: 'post',
})

complete.definition = {
    methods: ["post"],
    url: '/app/creator/onboarding-tour/complete',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\OnboardingTourController::__invoke
* @see app/Http/Controllers/Creator/OnboardingTourController.php:14
* @route '/app/creator/onboarding-tour/complete'
*/
complete.url = (options?: RouteQueryOptions) => {
    return complete.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\OnboardingTourController::__invoke
* @see app/Http/Controllers/Creator/OnboardingTourController.php:14
* @route '/app/creator/onboarding-tour/complete'
*/
complete.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: complete.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\OnboardingTourController::__invoke
* @see app/Http/Controllers/Creator/OnboardingTourController.php:14
* @route '/app/creator/onboarding-tour/complete'
*/
const completeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: complete.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\OnboardingTourController::__invoke
* @see app/Http/Controllers/Creator/OnboardingTourController.php:14
* @route '/app/creator/onboarding-tour/complete'
*/
completeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: complete.url(options),
    method: 'post',
})

complete.form = completeForm

const onboardingTour = {
    complete: Object.assign(complete, complete),
}

export default onboardingTour